module.exports = __webpack_public_path__ + "media/logos/accesos-original-4f6a6bd4.jpg";